import React, { useState } from "react";
import {
  Typography,
  Box,
  Button,
  IconButton,
  Grid,
  Stack,
  Divider,
  List,
  ListItem,
  Link,
  Container,
  TextField,
} from "@mui/material";
import CtBtn from "./CustomTool/CtBtn";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import { Link as RouterLink, useLocation } from "react-router-dom";

import { Facebook, LinkedIn, Twitter } from "@mui/icons-material";

function Footer({ notifyProcessing, closeUpdateProcessing, toastMsg, toastErrorMsg }) {
  const location = useLocation();
  return (
    <div>
      <Box
        component="footer"
        sx={{
          backgroundColor: "#003c79ff",
          color: "primary.contrastText",
          pt: 8,
          pb: 4,
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={4} justifyContent={"space-between"}>
            <Grid item xs={12} md={4}>
              <Typography
                variant="h6"
                sx={{ fontWeight: 700, mb: 2, color: "#ed3237" }}
              >
                <Box component="span" sx={{ color: "#ffffffff" }}>
                  RiTe{" "}
                </Box>
                Account
              </Typography>
              <Typography
                variant="body2"
                sx={{ opacity: 0.8, mb: 3, maxWidth: 300 }}
              >
                Modern billing & accounting software for small and medium
                businesses.
              </Typography>
              <Stack direction="row" spacing={1}>
                <IconButton
                  size="small"
                  href="https://www.facebook.com/share/1JLdvpm77V/"
                  target="_blank"
                  sx={{
                    color: "primary.contrastText",
                    backgroundColor: "rgba(255,255,255,0.1)",
                    "&:hover": { backgroundColor: "#ed3237" },
                  }}
                >
                  <Facebook fontSize="small" />
                </IconButton>
                <IconButton
                  size="small"
                  href="https://twitter.com"
                  target="_blank"
                  sx={{
                    color: "primary.contrastText",
                    backgroundColor: "rgba(255,255,255,0.1)",
                    "&:hover": { backgroundColor: "#ed3237" },
                  }}
                >
                  <Twitter fontSize="small" />
                </IconButton>
                <IconButton
                  size="small"
                  href="https://www.linkedin.com/company/ravitechworld/"
                  target="_blank"
                  sx={{
                    color: "primary.contrastText",
                    backgroundColor: "rgba(255,255,255,0.1)",
                    "&:hover": { backgroundColor: "#ed3237" },
                  }}
                >
                  <LinkedIn fontSize="small" />
                </IconButton>
              </Stack>
            </Grid>

            <Grid item xs={6} md={2}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                Product
              </Typography>
              <List dense sx={{ py: 0 }}>
                {[
                  { name: "Features", link: "#/" },
                  { name: "Pricing", link: "#/PricingPlans" },
                  { name: "Docs", link: "#/" },
                  { name: "Updates", link: "#/" },
                ].map((item) => (
                  <ListItem key={item.name} sx={{ py: 0.5, px: 0 }}>
                    <Link
                      component={RouterLink}
                      to={item.link.replace('#', '')}
                      sx={{
                        color: "primary.contrastText",
                        opacity: location.pathname === item.link.replace('#', '') ? 1 : 0.8,
                        fontWeight: location.pathname === item.link.replace('#', '') ? 600 : 400,
                        textDecoration: "none",
                        fontSize: "0.9rem",
                        "&:hover": {
                          opacity: 1,
                          color: "#ed3237",
                        },
                      }}
                    >
                      {item.name}
                    </Link>
                  </ListItem>
                ))}
              </List>
            </Grid>

            <Grid item xs={6} md={2}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                Company
              </Typography>
              <List dense sx={{ py: 0 }}>
                {[
                  { name: "Home", link: "#/" },
                  { name: "About", link: "#/about" },
                  { name: "Partners", link: "#/partner" },
                  { name: "Contact", link: "#/contact" },
                ].map((item) => (
                  <ListItem key={item.name} sx={{ py: 0.5, px: 0 }}>
                    <Link
                      component={RouterLink}
                      to={item.link.replace('#', '')}
                      sx={{
                        color: "primary.contrastText",
                        textDecoration: "none",
                        opacity: location.pathname === item.link.replace('#', '') ? 1 : 0.8,
                        fontWeight: location.pathname === item.link.replace('#', '') ? 600 : 400,
                        fontSize: "0.9rem",
                        "&:hover": {
                          opacity: 1,
                          color: "#ed3237",
                        },
                      }}
                    >
                      {item.name}
                    </Link>
                  </ListItem>
                ))}
              </List>
            </Grid>

            <Grid item xs={12} md={4}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                Stay Updated
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.8, mb: 2 }}>
                Subscribe to our newsletter for the latest updates
              </Typography>

              <Box
                component="form"
                onSubmit={(e) => {
                  e.preventDefault();
                  const emailValue = e.target.elements.subscribeEmail.value;
                  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                  if (!emailRegex.test(emailValue)) {
                    toastErrorMsg("Please enter a valid email address.", "subscribeEmail");
                    e.target.reset();
                    return;
                  }
                  toastMsg("success", "Subscribed successfully! Management coming soon.");
                  e.target.reset();
                }}
                sx={{ display: "flex", mb: 3 }}
              >
                <TextField
                  id="subscribeEmail"
                  name="subscribeEmail"
                  placeholder="Your email"
                  variant="outlined"
                  size="small"
                  required
                  type="email"
                  sx={{
                    mr: 1,
                    flexGrow: 1,
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "rgba(255,255,255,0.1)",
                      color: "primary.contrastText",
                      "& fieldset": {
                        borderColor: "rgba(255,255,255,0.3)",
                      },
                      "&:hover fieldset": {
                        borderColor: "rgba(255,255,255,0.5)",
                      },
                    },
                  }}
                />
                <CtBtn
                  type="submit"
                  variant="contained"
                  bgColor="#ed3237"
                  sx={{ borderRadius: 1 }}
                  label="Subscribe"
                />
              </Box>

              <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
                Contact
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.8, mb: 0.5 }}>
                support@riteaccount.com
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.8 }}>
                +91 80005 16051
              </Typography>
            </Grid>
          </Grid>

          <Divider sx={{ bgcolor: "rgba(255,255,255,0.2)", my: 4 }} />

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: "space-between",
              alignItems: { xs: "flex-start", sm: "center" },
            }}
          >
            <Typography
              variant="body2"
              sx={{ opacity: 0.7, mb: { xs: 2, sm: 0 } }}
            >
              © {new Date().getFullYear()} RiTe Account. All rights reserved.
            </Typography>

            <Box sx={{ display: "flex" }}>
              {[
                { name: "Privacy Policy", link: "#/privacy-policy" },
                { name: "Terms of Service", link: "#/terms-of-service" },
                { name: "Cookie Policy", link: "#/cookie-policy" },
              ].map((item) => (
                <Link
                  key={item.name}
                  component={RouterLink}
                  to={item.link.replace('#', '')}
                  sx={{
                    color: "primary.contrastText",
                    opacity: 0.7,
                    textDecoration: "none",
                    fontSize: "0.8rem",
                    ml: 3,
                    "&:hover": {
                      opacity: 1,
                      color: "#ed3237",
                    },
                  }}
                >
                  {item.name}
                </Link>
              ))}
            </Box>
          </Box>
        </Container>
      </Box>
    </div>
  );
}

export default HoCtToastContainer(Footer);
